"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const Node_1 = require("../Node");
const utils_1 = require("../utils");
const Rule_1 = require("../Rule");
const Transformation_1 = require("../Transformation");
// simpl=[
//   simpl($s)=$s,
//   $s+0=$s,
//   0+$s=$s,
//   $s-0=$s,
//   $s*0=0,
//   0*$s=0,
//   $s*1=$s,
//   1*$s=$s,
//   0/$s=0,
//   $s/$s=1,
//   0^$s=0,
//   $s^0=1,
//   $s^1=$s,
//   $s^$c*$s=$s^($c+1),
//   $s^$c/$s=$s^($c-1),
//   $s-$s=0
// ]
const name = 'simpl';
exports.simplify = utils_1.generateOperator(name);
const simplification = new Transformation_1.default(name, immutable_1.List([
    new Rule_1.default(exports.simplify(new Node_1.Rewritable('s')), new Node_1.Rewritable('s')),
    new Rule_1.default(utils_1.plus(new Node_1.Rewritable('s'), new Node_1.Num(0)), new Node_1.Rewritable('s')),
    new Rule_1.default(utils_1.plus(new Node_1.Num(0), new Node_1.Rewritable('s')), new Node_1.Rewritable('s')),
    new Rule_1.default(utils_1.minus(new Node_1.Rewritable('s'), new Node_1.Num(0)), new Node_1.Rewritable('s')),
    new Rule_1.default(utils_1.minus(new Node_1.Num(0), new Node_1.Rewritable('s')), utils_1.minus(new Node_1.Rewritable('s'))),
    new Rule_1.default(utils_1.mul(new Node_1.Rewritable('s'), new Node_1.Num(0)), new Node_1.Num(0)),
    new Rule_1.default(utils_1.mul(new Node_1.Num(0), new Node_1.Rewritable('s')), new Node_1.Num(0)),
    new Rule_1.default(utils_1.mul(new Node_1.Rewritable('s'), new Node_1.Num(1)), new Node_1.Rewritable('s')),
    new Rule_1.default(utils_1.mul(new Node_1.Num(1), new Node_1.Rewritable('s')), new Node_1.Rewritable('s')),
    new Rule_1.default(utils_1.div(new Node_1.Num(0), new Node_1.Rewritable('s')), new Node_1.Num(0)),
    new Rule_1.default(utils_1.div(new Node_1.Rewritable('s'), new Node_1.Rewritable('s')), new Node_1.Num(1)),
    new Rule_1.default(utils_1.pow(new Node_1.Num(0), new Node_1.Rewritable('s')), new Node_1.Num(0)),
    new Rule_1.default(utils_1.pow(new Node_1.Rewritable('s'), new Node_1.Num(0)), new Node_1.Num(1)),
    new Rule_1.default(utils_1.pow(new Node_1.Rewritable('s'), new Node_1.Num(1)), new Node_1.Rewritable('s')),
    new Rule_1.default(utils_1.mul(utils_1.pow(new Node_1.Rewritable('s'), new Node_1.Rewritable('c')), new Node_1.Rewritable('s')), utils_1.pow(new Node_1.Rewritable('s'), utils_1.plus(new Node_1.Rewritable('c'), new Node_1.Num(1)))),
    new Rule_1.default(utils_1.div(utils_1.pow(new Node_1.Rewritable('s'), new Node_1.Rewritable('c')), new Node_1.Rewritable('s')), utils_1.pow(new Node_1.Rewritable('s'), utils_1.minus(new Node_1.Rewritable('c'), new Node_1.Num(1)))),
    new Rule_1.default(utils_1.minus(new Node_1.Rewritable('s'), new Node_1.Rewritable('s')), new Node_1.Num(0)),
]));
exports.default = simplification;
//# sourceMappingURL=simplification.js.map